import { Flex, ScrollArea, Stack } from '@mantine/core';
import * as Sentry from '@sentry/react';
import { useState } from 'react';
import { useCreateTarget } from '../../../../../api/targets-client/targets-client.hooks';
import { TargetPayload } from '../../../../../api/targets-client/targets-client.type';
import i18n from '../../../../../base-dictionary';
import { useTargetsTabStore } from '../../../../../store/strategy-store/strategy-store';
import { baseWhite } from '../../../../../styles/design-tokens';
import { Button } from '../../../../../ui-library/button/button';
import { Divider } from '../../../../../ui-library/divider/divider';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Text } from '../../../../../ui-library/typography/typography';
import { TargetModal } from '../../../../adherence/targets/target-modal';
import { SmallSquareButton } from '../../../../financials/charts/shared/small-square-button';
import { useInitiativePerformance } from '../../initiative-performance.hooks';
import { getTargetModalInitialData } from './filters.helpers';
import { TargetItem } from './target-item';

export const Filters = ({ setShow }: { setShow: (show: boolean) => void }) => {
  const targets = useTargetsTabStore((state) => state.targets);
  const initiative = useInitiativePerformance();

  const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);

  const { createTarget, isCreating } = useCreateTarget();

  const handleCreateTarget = async (target: Partial<TargetPayload>) => {
    try {
      await createTarget(target);
      setIsTargetModalOpen(false);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  return (
    <Stack gap="md" h="100%">
      <Flex justify="space-between" align="center" w="100%">
        <Text size="medium" weight="bold">
          {i18n.t('strategy.initiative_performance.targets')}
        </Text>
        <Flex align="center" gap="xs">
          <Button
            size="xs"
            radius="xl"
            variant="primary"
            leftSection={<Icon name="add_circle_outline" color={baseWhite} size={16} pointer />}
            onClick={() => setIsTargetModalOpen(true)}
          >
            {i18n.t('strategy.initiative_performance.create_target')}
          </Button>
          <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
        </Flex>
      </Flex>
      <Divider />

      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <Stack gap="md">
          {targets.map((target) => (
            <TargetItem key={target.id} target={target} />
          ))}
        </Stack>
      </ScrollArea>

      {initiative && (
        <TargetModal
          opened={isTargetModalOpen}
          onClose={() => setIsTargetModalOpen(false)}
          onSave={handleCreateTarget}
          initialData={getTargetModalInitialData(initiative)}
          isCreating={true}
          isLoading={isCreating}
        />
      )}
    </Stack>
  );
};
